<template>
  <div>
    <div v-if="loading" class="text-center text-primary my-2">
      <b-spinner type="grow" class="align-middle"></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12">
          <div class="form-group" v-if="!branchRuleId">
            <label class="mt-3" for="name-rule-modal">{{
              $t('menu.settings.alertsNewsletters.labels.ruleName')
            }}</label>
            <input
              id="name-rule-modal"
              type="text"
              class="form-control"
              :placeholder="`${this.$t(
                'menu.settings.alertsNewsletters.placeholderRuleName',
              )}`"
              v-model="myRule.name"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.alertsNewsletters.feedbackRuleName') }}
            </div>
          </div>
        </div>
      </div>
      <hr v-if="!branchRuleId" />
      <div class="row mt-3">
        <div class="col-12">
          <div class="form-group" v-if="!branchRuleId">
            <b-form-checkbox
              v-model="myRule.expirationActive"
              name="check-button"
              switch
            >
              Dias para expiração
              <span class="header-icon" id="info-date-expiration"
                ><font-awesome-icon :icon="['fas', 'info-circle']"
              /></span>
            </b-form-checkbox>
            <input
              id="expire"
              type="number"
              class="form-control mt-2"
              placeholder="Expira em"
              v-model="myRule.expiresInDays"
            />
          </div>

          <b-popover
            target="info-date-expiration"
            triggers="hover"
            placement="top"
          >
            <template #title>Dias para expiração</template>
            Quando habilitado "Dias para expiração" e definido a quantidade de
            dias para expirar, após a resposta entrar no sistema passa a valer o
            tempo escolhido para expirar a tratativa daquela resposta. Ao
            ultrapassar o tempo configurado, o status passa a ser expirado.
          </b-popover>
        </div>
      </div>
      <hr v-if="!branchRuleId" />
      <p>
        <strong>{{
          $t('menu.settings.alertsNewsletters.emailsAlertNote')
        }}</strong>
      </p>
      <div v-for="(rule, i) in myRule.rules" :key="`${i}`">
        <div class="row">
          <div class="col-12 emails-area">
            <div class="form-group input-email mr-3">
              <label :for="`email-${i}-modal`">{{
                $t('menu.settings.alertsNewsletters.labels.email')
              }}</label>
              <input
                :id="`email-${i}-modal`"
                type="text"
                class="form-control"
                placeholder="Digite o email"
                v-model="rule.email"
              />
              <div class="invalid-feedback">
                {{ $t('menu.settings.alertsNewsletters.feedbackEmail') }}
              </div>
            </div>
            <div class="grade-checkbox-section mr-3">
              <div
                v-for="alert in rule.alerts"
                :key="alert.grade"
                class="grade-checkbox"
              >
                <b-form-checkbox
                  :id="`${alert.grade}-${i}${new Date()}-modal`"
                  v-model="alert.value"
                  class="check-alert-modal ml-3"
                >
                </b-form-checkbox>
                <label
                  :for="`${alert.grade}-${i}${new Date()}-modal`"
                  class="ml-1"
                  >{{ alert.grade }}</label
                >
              </div>
            </div>
            <div>
              <button @click="addNewEmail" class="btn btn-outline-primary">
                <font-awesome-icon :icon="['fas', 'plus']" />
              </button>
              <button @click="removeEmail(i)" class="btn btn-outline-danger">
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <div class="custom-switch">
              <input
                type="checkbox"
                class="custom-control-input just-comment"
                :id="`just-comment-type-${i}${new Date()}-modal`"
                v-model="rule.justComment"
              />
              <label
                class="custom-control-label"
                :for="`just-comment-type-${i}${new Date()}-modal`"
                >{{
                  $t('menu.settings.alertsNewsletters.labels.onlyReplyComment')
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <div class="custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="`select-all-${i}`"
                @click="selectAllNotes($event, i)"
              />
              <label :for="`select-all-${i}`" class="custom-control-label"
                >Selecionar todas as notas
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <p>
        <strong>{{ $t('menu.settings.alertsNewsletters.staggering') }}</strong>
      </p>
      <div class="row mb-4">
        <div class="col-12">
          <div class="row">
            <div class="col-10">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.levelOneEmail')
              }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="`${this.$t(
                  'menu.settings.alertsNewsletters.placeholderStaggering',
                )}`"
                v-model="myRule.level1.email"
              />
            </div>
            <div class="col-2">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.days')
              }}</label>
              <input
                type="number"
                class="form-control"
                placeholder="0"
                v-model="myRule.level1.days"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-10">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.levelTwoEmail')
              }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="`${this.$t(
                  'menu.settings.alertsNewsletters.placeholderStaggering',
                )}`"
                v-model="myRule.level2.email"
              />
            </div>
            <div class="col-2">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.days')
              }}</label>
              <input
                type="number"
                class="form-control"
                placeholder="0"
                v-model="myRule.level2.days"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-10">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.levelThreeEmail')
              }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="`${this.$t(
                  'menu.settings.alertsNewsletters.placeholderStaggering',
                )}`"
                v-model="myRule.level3.email"
              />
            </div>
            <div class="col-2">
              <label for="">{{
                $t('menu.settings.alertsNewsletters.labels.days')
              }}</label>
              <input
                type="number"
                class="form-control"
                placeholder="0"
                v-model="myRule.level3.days"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import api from '../../../../../../services/api';

export default {
  props: ['ruleId', 'editAlertRule', 'branchRuleId'],

  data: () => ({
    loading: false,
    errorMessage: null,
    selectAll: false,
  }),

  computed: {
    ...mapState('settings', ['companyAllUsers']),
    ...mapState('actions', ['action']),
    ...mapFields('alertRules', ['myRule']),
    ...mapState('actions', ['action']),
    ...mapState('companies', ['myMetric']),
  },

  async created() {
    this.loading = true;
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.branchRuleId) {
      await this.getBranchAlertRule();
    } else {
      const rules = []
      if (this.editAlertRule.rules.length == 1 && (this.editAlertRule.rules[0].email === "" || !this.editAlertRule.rules[0].email)) {

        if (
          this.myMetric === 'ces-1-5' ||
          this.myMetric === 'nps-1-5' ||
          this.myMetric === 'csat-1-5' ||
          this.myMetric === '5-stars' ||
          this.myMetric === 'csat-1-5(media)'
        ) {
          rules.push({
            email: null,
            justComment: false,
            alerts: [
              { grade: 1, value: false },
              { grade: 2, value: false },
              { grade: 3, value: false },
              { grade: 4, value: false },
              { grade: 5, value: false },
            ],
          });
        } else if (this.myMetric === 'like-dislike') {
          rules.push({
            email: null,
            justComment: false,
            alerts: [
              { grade: 0, value: false },
              { grade: 1, value: false },
            ],
          });
        } else {
          rules.push({
            email: null,
            justComment: false,
            alerts: [
              { grade: 0, value: false },
              { grade: 1, value: false },
              { grade: 2, value: false },
              { grade: 3, value: false },
              { grade: 4, value: false },
              { grade: 5, value: false },
              { grade: 6, value: false },
              { grade: 7, value: false },
              { grade: 8, value: false },
              { grade: 9, value: false },
              { grade: 10, value: false },
            ],
          });
        }
        this.myRule = this.editAlertRule;
        this.myRule.rules = rules;

      } else {
        this.myRule = this.editAlertRule;
      }
    }

    this.loading = false;
  },

  methods: {
    ...mapActions('alertRules', ['updateRule', 'setList']),

    async selectAllNotes(event, index) {
      if (event.target.checked === true)
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.myRule.rules[index].alerts.length; i++) {
          this.myRule.rules[index].alerts[i].value = true;
        }

      if (event.target.checked === false) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.myRule.rules[index].alerts.length; i++) {
          this.myRule.rules[index].alerts[i].value = false;
        }
      }
    },

    async getBranchAlertRule() {
      const response = await api.get(
        `${process.env.API_ROOT}/branch-alert-rule/${this.userAuth.companyId}/${this.branchRuleId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      this.myRule = { ...response.data };
    },

    addNewEmail() {
      if (
        this.myMetric === 'ces-1-5' ||
        this.myMetric === 'nps-1-5' ||
        this.myMetric === 'csat-1-5' ||
        this.myMetric === '5-stars' ||
        this.myMetric === 'csat-1-5(media)'
      ) {
        this.myRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
          ],
        });
      } else if (this.myMetric === 'like-dislike') {
        this.myRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 0, value: false },
            { grade: 1, value: false },
          ],
        });
      } else {
        this.myRule.rules.push({
          email: null,
          justComment: false,
          alerts: [
            { grade: 0, value: false },
            { grade: 1, value: false },
            { grade: 2, value: false },
            { grade: 3, value: false },
            { grade: 4, value: false },
            { grade: 5, value: false },
            { grade: 6, value: false },
            { grade: 7, value: false },
            { grade: 8, value: false },
            { grade: 9, value: false },
            { grade: 10, value: false },
          ],
        });
      }
    },

    removeEmail(index) {
      if (this.myRule.rules.length > 1) {
        this.myRule.rules.splice(index, 1);
      }
    },

    validateFields() {
      if (!this.myRule.name) {
        this.errorMessage = this.$t(
          'menu.settings.alertsNewsletters.messages.pleaseInsertNameRule',
        );
        return false;
      }

      const validate = true;

      if (!validate) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.emails-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .input-email {
    flex: 1;
  }

  .grade-checkbox-section {
    display: flex;
    align-items: center;
  }

  .grade-checkbox {
    width: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/edit-rule/tab-geral-edit/index.vue